module.exports = __webpack_public_path__ + "bec23af096541a0e797d8e26341102e7.MP3";